import { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import RatingDialog from './RatingDialog/RatingDialog';
import {
  useAddCafeRatingMutation,
  useUpdateCafeRatingMutation,
} from '../../../../store/api/cafeApi';
import { toast } from 'react-toastify';
const ViewsButton = styled(Button)(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: 'flex',
  color: '#000000',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  textTransform: 'none',
  '&:disabled': {
    color: '#000000',
  },
  [theme.breakpoints.down('sm')]: {
    paddingRight: '20px',
  },
}));
const ToastContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
});

const ButtonNumberLabel = styled('span')(() => ({
  marginLeft: '5px',
  fontWeight: '600',
}));

export default function RatingAction({ cafeData, currentId, isLogin }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const handleClickCancel = () => {
    setOpen(false);
  };

  const [handleRatingData] = useAddCafeRatingMutation();
  const [handleUpdateRatingData] = useUpdateCafeRatingMutation();

  let RatingAverageScore = 0,
    isUpdatingRate = false,
    currentUserNum = 0;
  if (cafeData) {
    let total = 0;
    cafeData.cafeRatings.forEach((item) => {
      total += item.ratingScore;
      if (item.userId == currentId) {
        isUpdatingRate = true;
        currentUserNum = item.ratingScore;
      }
    });
    RatingAverageScore = total / cafeData.cafeRatings.length;
  }

  const isBlock = !currentId || !isLogin;

  const clickToast = () => {
    if (isBlock) {
      toast.success('Please Sign in first.');
    }
    return;
  };

  const handleRating = async (event, value) => {
    const ratingObj = {
      userId: currentId,
      cafeId: cafeData._id,
      ratingScore: value,
    };
    if (isUpdatingRate) {
      await handleUpdateRatingData({ ratingObj });
    } else {
      await handleRatingData({ ratingObj });
    }
    setOpen(false);
  };
  return (
    <Box>
      <ToastContainer onClick={clickToast}>
        <ViewsButton onClick={handleOpen} disabled={isBlock}>
          {!isUpdatingRate ? (
            <StarOutlineIcon style={{ color: '#AB9178' }} />
          ) : (
            <StarIcon style={{ color: '#AB9178' }} />
          )}
          <ButtonNumberLabel>
            {!RatingAverageScore ? 'ADD' : RatingAverageScore.toFixed(1)}
          </ButtonNumberLabel>
        </ViewsButton>
      </ToastContainer>
      <RatingDialog
        img={cafeData.attachments}
        name={cafeData.cafeName}
        onClose={handleClose}
        open={open}
        currentUserNum={currentUserNum}
        cancelHandler={handleClickCancel}
        handleRating={handleRating}
      />
    </Box>
  );
}
